"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("../Icons/SvgIcon"));
const styled_1 = require("./styled");
const Loader = (_a) => {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(styled_1.Spinner, Object.assign({}, rest),
        react_1.default.createElement(SvgIcon_1.default, Object.assign({ "data-icon": "loader", viewBox: "0 0 16 16", fill: "none" }, rest),
            react_1.default.createElement("rect", { width: "300", height: "100", fill: "#030C14" }),
            react_1.default.createElement("circle", { className: "rotate", cx: "8", cy: "8", r: "7", style: { stroke: 'url(#Pattern)' }, strokeWidth: "2", "transform-origin": "8 8" }),
            react_1.default.createElement("path", { className: "rotate", "transform-origin": "8 8", d: "M9 15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15C7 14.4477 7.44772 14 8 14C8.55228 14 9 14.4477 9 15Z", fill: "url(#dot)" }),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("linearGradient", { id: "dot", x1: "9", y1: "15", x2: "8", y2: "15", gradientUnits: "userSpaceOnUse" },
                    react_1.default.createElement("stop", { stopColor: "#8698B1" }),
                    react_1.default.createElement("stop", { offset: "1", stopColor: "#8597B0" })),
                react_1.default.createElement("linearGradient", { id: "Gradient1", gradientTransform: "rotate(90)" },
                    react_1.default.createElement("stop", { offset: "0%", stopColor: "#454E5B" }),
                    react_1.default.createElement("stop", { offset: "100%", stopColor: "#030C14" })),
                react_1.default.createElement("linearGradient", { id: "Gradient2", gradientTransform: "rotate(90)" },
                    react_1.default.createElement("stop", { offset: "0%", stopColor: "#454E5B" }),
                    react_1.default.createElement("stop", { offset: "100%", stopColor: "#8597B0" })),
                react_1.default.createElement("pattern", { id: "Pattern", x: "0", y: "0", width: "16", height: "16", patternUnits: "userSpaceOnUse" },
                    react_1.default.createElement("g", { transform: "rotate(0, 8, 8)" },
                        react_1.default.createElement("rect", { shapeRendering: "crispEdges", x: "0", y: "0", width: "8", height: "16", fill: "url(#Gradient1)" }),
                        react_1.default.createElement("rect", { shapeRendering: "crispEdges", x: "8", y: "0", width: "8", height: "16", fill: "url(#Gradient2)" })))))));
};
exports.default = Loader;
//# sourceMappingURL=Loader.js.map